<template>
  <div class="animated fadeIn">
    <spot-prices/>
    <inventory-list v-bind:inventory_config="inventory_config"/>
    <announcement></announcement>
  </div>
</template>

<script>
import { Announcement } from '../../components/'

export default {
  name: 'inventory',
  components: {
    Announcement
  },
  data () {
    return {
      context: 'inventory context',
      inventory_config: {
        showName: true,
        showWeight: true,
        showInStock: true,
        showOrdered: true,
        showSalesOrder: true,
        showPricing: true,
        showBid: true,
        showCost: true,
        showAsk: true,
        showBuy: false,
        showSell: false,
        pageSize: 10,
        customerFilter: false
      }
    }
  },
  created () {
    document.body.classList.add('aside-menu-hidden')
  }
}
</script>



// WEBPACK FOOTER //
// src/views/inventory/Inventory.vue